/**
 * /app/trusts/$id/beneficial-ownership — Beneficial-ownership graph (route shell).
 *
 * NB: the URL is the hand-edited custom path `/beneficial-ownership` (NOT the
 * file-derived `/ownership`) — it is committed verbatim in routeTree.gen.ts.
 * Do NOT plugin-regenerate the route tree: it would rewrite this custom URL.
 * This shell keeps the exact `createFileRoute('/app/trusts/$id/beneficial-ownership')`
 * path string so the committed tree (which imports only `Route` here) stays valid.
 *
 * Screen impl in `./ownership-screen.tsx`, lazy-loaded via `lazyRouteComponent`.
 * A deep trust sub-tab (org / radial / list ownership views), not a first-paint
 * route, so the body leaves the entry bundle (200 kB gzip budget).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/app/trusts/$id/beneficial-ownership')({
  component: lazyRouteComponent(() => import('./ownership-screen'), 'BOScreen'),
});
